import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { resetLinkPassword } from '../../api/publicApis';
import { isStrongPassword } from '../../utils/helper';
import RequestDemoBtn from '../request-demo-btn';
import transportIcon from '../../assets/icons/login.png';
import eyeIcon from '../../assets/icons/new_icon/eye.svg';
import eyeSlashIcon from '../../assets/icons/new_icon/eye-slash.svg';

function ResetPassword() {
  let navigate = useNavigate();
  const location = useLocation();
  const resetId = new URLSearchParams(location.search).get('reset');
  const { enqueueSnackbar } = useSnackbar();
  const [passwordOne, setPasswordOne] = useState('');
  const [passwordTwo, setPasswordTwo] = useState('');
  const [loading, setLoading] = useState(false);
  const [validating, setValidating] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  function actionHandle() {
    setValidating(true);
    if (isStrongPassword(passwordOne) && passwordOne === passwordTwo) {
      setLoading(true);
      let payload = {
        password_one: passwordOne,
        password_two: passwordTwo,
        reset_id: resetId,
      };
      resetLinkPassword(payload)
        .then((response) => {
          if (!response?.data?.is_error) {
            setLoading(false);
            navigate('/login');
            enqueueSnackbar('Password has been updated.', {
              variant: 'success',
            });
          }
        })
        .catch((e) => {
          setLoading(false);
        });
    }
  }
  return (
    <>
      <div className=''>
        {loading && (
          <div className='loader-container'>
            <div className='spinner'></div>
          </div>
        )}
      </div>
      <div className='row h-100   w-100 m-0'>
        <div className='col-sm-12 col-md-12 col-lg-6 my-auto text-center d-none d-lg-block h-100'>
          <div className='p-5'>
            <div className='row d-flex align-items-center justify-content-center'>
              <div className='col-12'>
                <img
                  className='mx-auto img-fluid'
                  src={transportIcon}
                  alt='ubbe computer'
                />
              </div>
              <div
                className=' col-12 lex-20-400 text-center mt-1'
                style={{ width: '424px' }}
              >
                “Access an unparalleled network of transportation partners”
              </div>
            </div>
          </div>
        </div>
        <div className='col-sm-12 col-md-12 col-lg-6 bg-main min-vh-100'>
          <div className='w-100   h-100'>
            <div className=' d-flex align-items-center justify-content-center justify-content-lg-start ms-5 h-100'>
              <div>
                <div className='mb-4'>
                  <h2 className='text-white lex-48-700'>Reset Password</h2>
                </div>
                <div className='d-flex flex-column align-items-center justify-content-start mb-3 w-100'>
                  <ul className='text-white'>
                    <li>
                      Your password can't be too similar to your other personal
                      information.
                    </li>
                    <li>Your password must contain at least 14 characters.</li>
                    <li>Your password can't be a commonly used password.</li>
                    <li>Your password can't be entirely numeric.</li>
                    <li>
                      Your password must contain at least 2 uppercase letter,
                      A-Z.
                    </li>
                    <li>
                      Your password must contain at least 2 special character:
                      !@#$%^&*;:.-
                    </li>
                  </ul>
                </div>

                <div className='d-flex flex-column align-items-center justify-content-start mb-3'>
                  <label
                    htmlFor='username'
                    className='form-label  color-white align-self-start lex-18-400 mb_0'
                  >
                    Password <span className='text-danger'>*</span>
                  </label>
                  <div className='d-flex w-100'>
                    <div className='position-absolute  password-input'>
                      <input
                        type={showPassword ? 'text' : 'password'}
                        className='form-control ubbe-input w-100'
                        id='password'
                        name='password'
                        autoComplete='new-password'
                        placeholder='Your Password'
                        value={passwordOne}
                        onChange={(e) => setPasswordOne(e.target.value)}
                      />
                      {validating && !isStrongPassword(passwordOne) && (
                        <div className='error_text'>
                          {'Please provide a strong password.'}
                        </div>
                      )}
                      <span
                        className='eye-icon cursor_pointer'
                        onClick={() => {
                          setShowPassword((prev) => !prev);
                        }}
                      >
                        <img
                          src={showPassword ? eyeSlashIcon : eyeIcon}
                          alt='@eye'
                        />
                      </span>
                    </div>
                  </div>
                </div>
                <div className='d-flex flex-column align-items-center justify-content-start mb-3 confirm-password-label'>
                  <label
                    htmlFor='username'
                    className='form-label  color-white align-self-start lex-18-400 mb_0'
                  >
                    Confirm Password <span className='text-danger'>*</span>
                  </label>
                  <div className='d-flex w-100'>
                    <div className='position-absolute password-input confirm-password-input'>
                      <input
                        type={showConfirmPassword ? 'text' : 'password'}
                        className='form-control ubbe-input w-100'
                        id='password'
                        name='password'
                        autoComplete='new-password'
                        placeholder='Your Password'
                        value={passwordTwo}
                        onChange={(e) => setPasswordTwo(e.target.value)}
                      />
                      {validating && passwordOne !== passwordTwo && (
                        <div className='error_text'>
                          {
                            'Please provide a same password and confirm password.'
                          }
                        </div>
                      )}
                      <span
                        className='eye-icon cursor_pointer'
                        onClick={() => {
                          setShowConfirmPassword((prev) => !prev);
                        }}
                      >
                        <img
                          src={showConfirmPassword ? eyeSlashIcon : eyeIcon}
                          alt='@eye'
                        />
                      </span>
                    </div>
                  </div>
                </div>
                <div className='row mb-1' style={{ marginTop: '80px' }}>
                  <div className='col-md-12'>
                    <button
                      onClick={actionHandle}
                      className='btn btn-ubbe-green rounded-5 p-2 w-100 lex-18-400'
                      id='find-out-more-benefits'
                    >
                      Reset Password
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ResetPassword;
